"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubMenuLink = void 0;
require("core-js/modules/es.object.assign.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _hooks = require("../../../../hooks");
var _MenuItemContent = require("./MenuItemContent");
var _ActiveSubMenuItem = require("./ActiveSubMenuItem");
var _MenuPropTypes = require("./MenuPropTypes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SubMenuLink = _ref => {
  let {
    subMenuItem,
    subMenuIsOpen,
    customTrackingData,
    customTrackingEvents
  } = _ref;
  const {
    url,
    isActive,
    menuItems,
    icons,
    isReactRouterLink
  } = subMenuItem;
  const hasSubmenu = menuItems && menuItems.length > 0;
  const subMenuLink = (0, _react.useRef)(null);
  const hasRightIcon = icons && icons.right;
  const hasLeftIcon = icons && icons.left;
  (0, _hooks.useTracking)({
    elementRef: subMenuLink,
    trackingProps: {
      label: subMenuItem.label,
      elementType: 'a',
      url
    },
    customTrackingData,
    customTrackingEvents
  });
  if (!url) {
    return null;
  }
  if (isActive) {
    return /*#__PURE__*/_react.default.createElement(_ActiveSubMenuItem.ActiveSubMenuItem, {
      subMenuItem: subMenuItem,
      subMenuIsOpen: subMenuIsOpen
    });
  }
  const linkProps = {
    ref: subMenuLink,
    className: "".concat(hasLeftIcon ? 'hasLeftIcon' : '', " ").concat(hasRightIcon ? 'hasRightIcon' : '')
  };
  if (isReactRouterLink) {
    return /*#__PURE__*/_react.default.createElement(_reactRouterDom.NavLink, _extends({
      to: url
    }, linkProps), /*#__PURE__*/_react.default.createElement(_MenuItemContent.MenuItemContent, {
      itemDefinition: subMenuItem,
      isOpen: subMenuIsOpen || subMenuItem.isOpen,
      renderRightIcon: !hasSubmenu
    }));
  }
  return /*#__PURE__*/_react.default.createElement("a", _extends({
    href: url
  }, linkProps), /*#__PURE__*/_react.default.createElement(_MenuItemContent.MenuItemContent, {
    itemDefinition: subMenuItem,
    isOpen: subMenuIsOpen || subMenuItem.isOpen,
    renderRightIcon: !hasSubmenu
  }));
};
exports.SubMenuLink = SubMenuLink;
SubMenuLink.propTypes = {
  subMenuIsOpen: _propTypes.default.bool,
  subMenuItem: _propTypes.default.shape(_MenuPropTypes.MenuButtonPropTypes),
  // eslint-disable-next-line react/forbid-prop-types
  customTrackingData: _propTypes.default.any,
  customTrackingEvents: _propTypes.default.arrayOf(_propTypes.default.string)
};